import React from "react"
import { firestore } from "../../core"
import { useFollowers } from "popopo-lib-front/firestore-access"
import { NavLink } from "react-router-dom"
import * as FirebaseAuth from "firebase/auth"
import { UserDocument } from "popopo-msg"
import { Paths } from "../../paths"
import { UserId } from "popopo-msg"


export const FollowUserList = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const users = useFollowers(firestore, props.user.id, 100)

  return (
    <>
      <ul className="list-group w-100">
        {users === "loading" ? (
          <li>
            <i className="fas fa-spin fa-spinner" />
          </li>
        ) : users.length === 0 ? (
          <li>ユーザーは1人も存在しません。</li>
        ) : (
          users.map((user) => (
            <li key={user.id} className="list-group-item d-flex justify-content-between align-items-center">
              <NavLink to={Paths.users.user.getPath(UserId(user.id))}>
                ID: {user.id} (Created at: {user.created_at})
              </NavLink>
              {user.is_followed_back && (
                <span className="badge bg-primary rounded-pill">相互</span>
              )}
            </li>
          ))
        )}
      </ul>
    </>
  )
}
